// services/printService.js
import { BASE_API } from '../utils/constants';

/**
 * Genera y obtiene un documento PDF desde el API
 * @param {string} token - Token de autenticación
 * @param {string} reportType - Tipo de reporte (ej: 'factura', 'resumen')
 * @param {string} reportName - Nombre del reporte
 * @param {Object} data - Datos para el reporte
 * @returns {Promise<string>} URL del objeto PDF
 */
export async function getPrintDocumentApi(token, reportType, reportName, data) {
  try {
    const url = `${BASE_API}/api/impresiones/hotel/${encodeURIComponent(reportType)}/${encodeURIComponent(reportName)}/pdf`;
    console.log(" url => ",url);
    
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const errorData = await response.json();
        throw new Error(errorData.msg || errorData.details || "Error al generar el PDF");
      }
      throw new Error("Error al generar el PDF");
    }

    const blob = await response.blob();
    const pdfBlob =
      blob.type === "application/pdf"
        ? blob
        : new Blob([blob], { type: "application/pdf" });

    return URL.createObjectURL(pdfBlob);
  } catch (error) {
    console.error('❌ Error en getPrintDocumentApi:', error);
    throw error;
  }
}

/**
 * Abre el PDF en una nueva ventana o pestaña
 * @param {string} pdfUrl - URL del objeto PDF
 * @param {string} filename - Nombre del archivo (opcional)
 */
export function openPdfInNewTab(pdfUrl, filename = 'documento.pdf') {
  // Abrir en nueva pestaña
  const win = window.open(pdfUrl, '_blank');
  
  // Si el navegador bloquea la apertura, descargar directamente
  if (!win) {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

/**
 * Descarga el PDF directamente
 * @param {string} pdfUrl - URL del objeto PDF
 * @param {string} filename - Nombre del archivo
 */
export function downloadPdf(pdfUrl, filename = 'documento.pdf') {
  const link = document.createElement('a');
  link.href = pdfUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}